// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("@nathanvda/cocoon")
require("chartkick")
require("chart.js")
require('controllers')
var _ = require('lodash');

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


// ----------------------------------------------------
// Note(lewagon): ABOVE IS RAILS DEFAULT CONFIGURATION
// WRITE YOUR OWN JS STARTING FROM HERE 👇
// ----------------------------------------------------

// External imports
import "bootstrap";
import intlTelInput from 'intl-tel-input';

document.addEventListener('turbolinks:load', (event) => {
  const input = document.querySelector("#tixer_phone_number");
  if (input) {
    const iti = intlTelInput(input, {
      placeholderNumberType: "MOBILE",
      preferredCountries: ["fr"],
      autoPlaceholder: "aggressive",
      hiddenInput: "phone_number",
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.3/build/js/utils.js"
    });
  };
})

// Internal imports, e.g:
// import { initSelect2 } from '../components/init_select2';
// document.addEventListener('turbolinks:load', () => {
//   // Call your functions here, e.g:
//   // initSelect2();
// });

document.addEventListener('turbolinks:load', (event) => {
  const scrollPosition = localStorage.getItem('scrollPosition');
  if (scrollPosition) {
    window.scrollTo({ top: parseInt(scrollPosition, 10), behavior: 'instant' })
    localStorage.setItem('scrollPosition', 0)
  }
})

// Direct Upload
import { directUpload } from '../components/direct_upload';
document.addEventListener('turbolinks:load', () => {
  directUpload();
});


// Mapbox

import { initMapbox } from '../plugins/init_mapbox';

document.addEventListener('turbolinks:load', () => {
  initMapbox();
})

// Avatar preview

import { previewAvatarOnFileSelect } from '../components/avatar_preview';

document.addEventListener('turbolinks:load', () => {
  // Call your JS functions here
  previewAvatarOnFileSelect();
});

import { activateTixerInvitationOnClick } from '../components/tixer_choice';

document.addEventListener('turbolinks:load', () => {
  // Call your JS functions here
  activateTixerInvitationOnClick();
});

// tooltips

document.addEventListener('turbolinks:load', () => {
  // Call your JS functions here
  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })
});

import "controllers"
